import { aroFetch } from "../aroApi";
import { PersonDetail, PersonListResponse, PersonSearchParams } from "../../types/aro";

export async function fetchPersons(params: PersonSearchParams): Promise<PersonListResponse> {
  const qs = new URLSearchParams();
  if (params.name)                                                qs.set("name",             params.name);
  if (params.email)                                               qs.set("email",            params.email);
  if (params.certificate_name)                                    qs.set("certificate_name", params.certificate_name);
  if (params.event_id)                                            qs.set("event_id",         params.event_id);
  if (params.tracking_status && params.tracking_status !== "all") qs.set("tracking_status",  params.tracking_status);
  if (params.no_linkedin)                                         qs.set("no_linkedin",      "true");
  qs.set("limit",  String(params.limit  ?? 50));
  qs.set("offset", String(params.offset ?? 0));
  return aroFetch<PersonListResponse>(`/api/persons?${qs.toString()}`);
}

export async function fetchPersonById(id: string | number): Promise<PersonDetail> {
  return aroFetch<PersonDetail>(`/api/persons/${id}`);
}

export async function updatePerson(
  id: string | number,
  fields: { full_name?: string; linkedin_url?: string },
  changed_by: string
): Promise<PersonDetail> {
  return aroFetch<PersonDetail>(`/api/persons/${id}`, {
    method: "PATCH",
    body: JSON.stringify({ ...fields, changed_by }),
  });
}
